// extracted by mini-css-extract-plugin
export default {"bottomNav":"bottomNav_bottomNav__peEnd","createEventFAB":"bottomNav_createEventFAB__h0tmI","hidden":"bottomNav_hidden__rDk-7","btns":"bottomNav_btns__bt-qr"};